import React from 'react';
import { Segment } from 'semantic-ui-react';

import Button from '../../../components/Button';
import BiometryStatusCard from './BiometryStatusCard';
import { RecipientBiometryMetaDTO } from '../../../services/standalone-charges';

type Props = {
  openKycLink: () => void;
  loadActivationStatus: () => void;
  activationLoading: boolean;
  activationKycPageUrl: string;
  onEditActivation?: () => void;
  activationIsBiometryRejected?: boolean;
  activationIsSupportRequired?: boolean;
  canRetryBiometry?: boolean;
  activationBiometryMeta?: RecipientBiometryMetaDTO | null;
  onRetryBiometry?: () => void;
};

const KycBanner: React.FC<Props> = ({
  openKycLink,
  loadActivationStatus,
  activationLoading,
  activationKycPageUrl,
  onEditActivation,
  activationIsBiometryRejected = false,
  activationIsSupportRequired = false,
  canRetryBiometry = false,
  activationBiometryMeta,
  onRetryBiometry
}) => {
  if (activationIsSupportRequired) {
    return (
      <Segment>
        <BiometryStatusCard variant="support" meta={activationBiometryMeta} />
      </Segment>
    );
  }

  if (activationIsBiometryRejected) {
    const variant = canRetryBiometry ? 'rejected' : 'limitReached';

    return (
      <Segment>
        <BiometryStatusCard variant={variant} meta={activationBiometryMeta}>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {canRetryBiometry && onRetryBiometry && (
              <Button
                type="button"
                text="Tentar biometria novamente"
                onClick={onRetryBiometry}
              />
            )}
            {onEditActivation && (
              <Button type="button" text="Editar cadastro" light onClick={onEditActivation} />
            )}
            <Button
              type="button"
              text="Atualizar status"
              light
              onClick={loadActivationStatus}
              loading={activationLoading}
              disabled={activationLoading}
            />
          </div>
        </BiometryStatusCard>
      </Segment>
    );
  }

  return (
    <Segment>
      <BiometryStatusCard variant="pending" meta={activationBiometryMeta}>
        {activationKycPageUrl && (
          <p style={{ marginBottom: 12 }}>
            <a href={activationKycPageUrl} target="_blank" rel="noopener noreferrer">
              Abrir página de biometria
            </a>
          </p>
        )}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Button type="button" text="Abrir biometria" onClick={openKycLink} />
          {onEditActivation && (
            <Button type="button" text="Editar cadastro" light onClick={onEditActivation} />
          )}
          <Button
            type="button"
            text="Atualizar status"
            light
            onClick={loadActivationStatus}
            loading={activationLoading}
            disabled={activationLoading}
          />
        </div>
      </BiometryStatusCard>
    </Segment>
  );
};

export default KycBanner;
